import {
  H2, TableContainer, SectionContainer, TableHeader,
  TableBodyContainer
} from 'components/shared'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { GenreTypes, PersonRoles, ProjectTypes } from 'models'
import React from 'react'
import { PERSON_PROJECTS_TABLE_STORE } from 'store'
import { PersonProjectsTableSortProps } from 'store/PersonProjectsTableStore/PersonProjectsTableStore.types'
import { getTableHeight } from 'utilities'
import styles from './ProjectsSection.module.scss'
import { personProjectsTableWidths, ProjectsSectionProps } from './ProjectsSection.types'
import { TableProjectLine } from './TableProjectLine'
import cl from 'classnames'
import tableBodyContainerStyle from '../../../../components/shared/TableBodyContainer/TableBodyContainer.module.scss'

const ProjectsSectionComponent = (props: ProjectsSectionProps) => {
  const {
    [PERSON_PROJECTS_TABLE_STORE]: {
      searchResults,
      // getRolesByProjectId,
      onSearchPropsChange,
      searchProps,
      getSortDirection,
      handleSortDirectionChange,
      isColumnMarked,
      projectsCount
    }
  } = props

  if (projectsCount === 0) return null

  const tableHeight = getTableHeight(projectsCount+2)
  const scrollbarSpacing = 4.8

  return (
    <SectionContainer className={styles.container} extraPaddingBottom>
      <H2>Projects</H2>
      <TableContainer
        noBoxShadow
        className={cl(styles.tableContainer, styles.thinScroll)}
        style={{
          maxHeight: tableHeight,
          // minHeight: 550,
          height: tableHeight,
          overflowX: 'auto'
        }}
      >
        <TableHeader
          tableColumns={[
            {
              label: 'project name',
              // widthPercentage: personProjectsTableWidths.name,
              widthPx: personProjectsTableWidths.name,
              inputProps: {
                placeholder: 'Search...',
                value: searchProps.name,
                onChange: name => onSearchPropsChange({ name })
              },
              sortDirection: getSortDirection(PersonProjectsTableSortProps.NAME),
              setSortDirection: handleSortDirectionChange(PersonProjectsTableSortProps.NAME),
              isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.NAME)
            },
            {
              label: 'type',
              // widthPercentage: personProjectsTableWidths.type,
              widthPx: personProjectsTableWidths.type,
              selectProps: {
                options: Object.values(ProjectTypes).map(type => ({
                  label: type,
                  value: type
                })),
                noneLabel: 'All',
                value: searchProps.type,
                onChange: (type: ProjectTypes) => onSearchPropsChange({ type })
              },
              sortDirection: getSortDirection(PersonProjectsTableSortProps.TYPE),
              setSortDirection: handleSortDirectionChange(PersonProjectsTableSortProps.TYPE),
              isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.TYPE)
            },
            {
              label: 'role in project',
              // widthPercentage: personProjectsTableWidths.role,
              widthPx: personProjectsTableWidths.role,
              selectProps: {
                options: Object.values(PersonRoles).map(role => ({
                  label: role,
                  value: role
                })),
                noneLabel: 'All',
                value: searchProps.role,
                onChange: role => onSearchPropsChange({ role })
              },
              sortDirection: getSortDirection(PersonProjectsTableSortProps.ROLE),
              setSortDirection: handleSortDirectionChange(PersonProjectsTableSortProps.ROLE),
              isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.ROLE)
            },
            {
              label: 'genre',
              // widthPercentage: personProjectsTableWidths.genre,
              widthPx: personProjectsTableWidths.genre,
              selectProps: {
                options: Object.values(GenreTypes).map(genre => ({
                  label: genre,
                  value: genre
                })),
                noneLabel: 'All',
                value: searchProps.genre,
                onChange: genre => onSearchPropsChange({ genre })
              },
              sortDirection: getSortDirection(PersonProjectsTableSortProps.GENRE),
              setSortDirection: handleSortDirectionChange(PersonProjectsTableSortProps.GENRE),
              isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.GENRE)
            },
            {
              label: 'published',
              // widthPercentage: personProjectsTableWidths.published,
              widthPx: personProjectsTableWidths.published + scrollbarSpacing,
              selectProps: {
                options: [{ value: true, label: 'Yes' }, { value: false, label: 'No' }],
                noneLabel: 'All',
                value: searchProps.published,
                onChange: published => onSearchPropsChange({ published })
              }
            }
          ]}
        />
        <TableBodyContainer className={tableBodyContainerStyle.tableBodyContainer}>
          {searchResults.map(project => (
            <TableProjectLine
              key={project.id}
              project={project}
            />
          ))}
        </TableBodyContainer>
      </TableContainer>
    </SectionContainer>
  )
}

const ProjectsSection = inject(
  PERSON_PROJECTS_TABLE_STORE
)(observer(ProjectsSectionComponent))
export { ProjectsSection }
